import React from 'react'
import SearchableSelect from '../../../shared/components/SearchableSelect'
import type {CurrencyOption} from '../core/_requests'

type CurrencySelectProps = {
  value?: string
  onChange: (value: string) => void
  currencies: CurrencyOption[]
  loading?: boolean
  error?: string | null
  required?: boolean
  className?: string
  ariaLabel?: string
}

const CurrencySelect: React.FC<CurrencySelectProps> = ({
  value,
  onChange,
  currencies,
  loading = false,
  error = null,
  required = false,
  className = 'form-control',
  ariaLabel = 'Currency',
}) => {
  const hasCurrencies = currencies.length > 0
  const selectedValue = hasCurrencies ? value || '' : ''

  return (
    <>
      <SearchableSelect
        aria-label={ariaLabel}
        className={className}
        value={selectedValue}
        onChange={(e) => onChange(e.target.value)}
        disabled={loading || !hasCurrencies}
        required={required}
      >
        {loading ? (
          <option value='' disabled>
            Loading currencies...
          </option>
        ) : error ? (
          <option value='' disabled>
            Unable to load currencies
          </option>
        ) : !hasCurrencies ? (
          <option value='' disabled>
            No active currencies found
          </option>
        ) : (
          currencies.map((currency) => (
            <option key={currency.code} value={currency.code}>
              {currency.code} - {currency.displayName}
              {currency.symbol ? ` (${currency.symbol})` : ''}
            </option>
          ))
        )}
      </SearchableSelect>
      {loading && <small className='text-muted'>Loading active currencies...</small>}
      {!loading && error && <small className='text-danger'>{error}</small>}
      {!loading && !error && !hasCurrencies && (
        <small className='text-warning'>No active currencies are available.</small>
      )}
    </>
  )
}

export default CurrencySelect
